import React from "react";
import { useParams } from "react-router-dom";
import FreshStart from "./components/FreshStart-details";
import SpeakYourMind from "./components/SpeakYourMind-details";
import EnglishAtWork from "./components/EnglishAtWork-details";
import PhonoKEY from "./components/PhonoKEY-details";
import DictationCourse from "./components/DictationCourse-details";
import IntonationCourse from "./components/IntonationCourse-details";
import VocaBoost from "./components/VocaBoost-details";
import IELTS from "./components/IELTS&TOEIC-details";


const Details = () => {
  const { category } = useParams();
  console.log(category);
  const decodedCategory = decodeURIComponent(category);
  console.log(decodedCategory);

  const renderComponent = () => {
    switch (decodedCategory) {
      case "Fresh Start":
        return <FreshStart />;
      case "Speak Your Mind":
        return <SpeakYourMind />;
      case "English At Work":
        return <EnglishAtWork />;
      case "Phono KEY":
        return <PhonoKEY />;
      case "Dictation Course":
        return <DictationCourse />;
      case "Intonation Course":
        return <IntonationCourse />;
      case "VocaBoost":
        return <VocaBoost />;
      case "Ielts & Toeic":
        return <IELTS />;

      default:
        return null;
    }
  };

  return <div>{renderComponent()}</div>;
};

export default Details;
